import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { userDetailsInitialState } from "./intialState";

const recruiterDetailsSlice = createSlice({
    name: "recruiterDetails",
    initialState: () => {
        const initialState = { ...userDetailsInitialState }
        return initialState
    },
    reducers: {
      
  
    },
});

export const {
    
} = recruiterDetailsSlice.actions;

export default recruiterDetailsSlice;